/**
 * Cookie names + constants shared between `src/middleware.ts` and the rollout
 * cleanup. Deliberately free of any API-client imports: `middleware.ts` imports
 * this module statically on every request, so pulling in the API client here would
 * bloat the hot middleware path. The actual cleanup logic
 * (`rolloutCleanup.ts`, which does import the API client) is dynamically imported
 * only for rollout-tagged beta users.
 */

/**
 * HotPads Next beta cookie contract:
 *
 * - `hp_next=true` routes the browser to hotpads-web-next. It does not describe
 *   why the user is there.
 * - `betaRollout=<experiment>` means legacy auto-enrolled the user from the
 *   real backend ZEXP treatment. Rollout cleanup is allowed to evict only this
 *   source when that backend treatment becomes off/control.
 * - Manual enables and HPWEB_* query overrides must not write `betaRollout`;
 *   they can set `hp_next=true`, but cleanup must not treat them as rollout users.
 * - `betaRolloutOptOut=<experiment>` records an explicit manual beta clear.
 *   Every manual beta clear path writes it; every manual beta enable clears it.
 */

// HAProxy routing flag.
export const HP_NEXT_COOKIE = 'hp_next';

// Source marker written by legacy hotpads-web when it auto-enrolls a user via the
// real backend rollout experiment. Its value is the experiment name.
export const BETA_ROLLOUT_MARKER_COOKIE = 'betaRollout';

// Explicit manual opt-out marker. Legacy rollout enrollment suppresses normal
// ZEXP auto-enrollment while this is present; manual enable clears it.
export const BETA_ROLLOUT_OPT_OUT_COOKIE = 'betaRolloutOptOut';
export const BETA_ROLLOUT_EXPERIMENT = 'HOTPADS_WEB_NEXT_REWRITE';

// Deprecated next-internal check marker. Kept only to clear stale cookies
// written by older deployments; current cleanup checks ZEXP on every eligible GET.
export const BETA_CHECK_COOKIE = 'betaRolloutCheckedAt';

// Cap the per-request ZEXP call so middleware never blocks navigation for long.
export const ZEXP_TIMEOUT_MS = 500;
